/* eslint-disable-next-line */
export interface ConfigureProps {}

export function Configure(props: ConfigureProps) {
  return (
    <div>
      <h1>Welcome to Configure!</h1>
    </div>
  )
}

export default Configure
